module.exports = __webpack_public_path__ + "img/icra-logo-en.843e73b3.png";